import React from "react";
import { TrendingUp, TrendingDown, Minus } from "lucide-react";
import { probColor } from "../../lib/constants";

export const TREND = {
  crescita: { icon: TrendingUp, color: "#22C55E", label: "In crescita" },
  calo: { icon: TrendingDown, color: "#EF4444", label: "In calo" },
  stabile: { icon: Minus, color: "#EAB308", label: "Stabile" },
  "n.d.": { icon: Minus, color: "#64748B", label: "Trend n.d." },
};

const FACTORS = [
  ["bisogno", "Bisogno"], ["fit", "Fit servizi"], ["raggiungibilita", "Raggiungibilità"],
  ["budget", "Segnali budget"], ["andamento", "Andamento"], ["storico_pipeline", "Storico pipeline"],
];
const CHANNELS = [["sito", "Sito"], ["social", "Social"], ["google_adv", "Google Adv"], ["instagram", "Instagram"]];

const trendCaption = (t) => (t?.followers_delta_pct != null
  ? `${t.followers_delta_pct > 0 ? "+" : ""}${t.followers_delta_pct}% follower`
  : `Attività: ${t?.activity || "n.d."}`);

export const AcquisitionSummary = ({ acq }) => {
  const trend = TREND[acq.trend?.label] || TREND["n.d."];
  const TrendIcon = trend.icon;
  const color = probColor(acq.probability);

  return (
    <>
      <div className="grid grid-cols-3 gap-3">
        <div className="rounded-xl border p-3 text-center" style={{ borderColor: color + "66", background: color + "0D" }} data-testid="acq-probability">
          <div className="font-heading text-3xl font-bold tabular-nums" style={{ color }}>{acq.probability}%</div>
          <div className="label-caps mt-1 text-muted-foreground">Prob. acquisizione</div>
        </div>
        <div className="rounded-xl border border-border p-3 text-center" data-testid="acq-priority-index">
          <div className="font-heading text-3xl font-bold tabular-nums text-primary">{acq.priority_index}</div>
          <div className="label-caps mt-1 text-muted-foreground">Indice priorità</div>
        </div>
        <div className="rounded-xl border border-border p-3 text-center" data-testid="acq-trend">
          <div className="flex items-center justify-center gap-1 font-heading text-lg font-bold" style={{ color: trend.color }}>
            <TrendIcon className="h-5 w-5" /> {trend.label}
          </div>
          <div className="label-caps mt-1 text-muted-foreground">{trendCaption(acq.trend)}</div>
        </div>
      </div>

      <div className="grid grid-cols-4 gap-2" data-testid="channel-scores">
        {CHANNELS.map(([k, l]) => (
          <div key={k} className="rounded-lg border border-border p-2 text-center">
            <div className="font-heading text-lg font-bold tabular-nums">{acq.channel_scores?.[k] ?? "—"}<span className="text-xs text-muted-foreground">/10</span></div>
            <div className="text-[0.6rem] uppercase tracking-wide text-muted-foreground">{l}</div>
          </div>
        ))}
      </div>

      <div className="space-y-2 rounded-xl border border-border p-4">
        <div className="label-caps text-muted-foreground">Fattori di acquisizione</div>
        {FACTORS.map(([k, l]) => (
          <div key={k} className="space-y-1">
            <div className="flex justify-between text-xs"><span>{l}</span><span className="tabular-nums">{acq.factors?.[k] ?? 0}%</span></div>
            <div className="h-1.5 w-full rounded bg-secondary"><div className="h-full rounded bg-primary" style={{ width: `${acq.factors?.[k] ?? 0}%` }} /></div>
          </div>
        ))}
        {acq.history_sample != null && (
          <div className="pt-1 text-[0.65rem] text-muted-foreground">Storico pipeline basato su {acq.history_sample} trattative chiuse{acq.history_sample < 3 ? " (poche: il peso si affina chiudendo clienti)" : ""}.</div>
        )}
      </div>

      {acq.reasons?.length > 0 && (
        <div className="flex flex-wrap gap-1.5" data-testid="acq-reasons">
          {acq.reasons.map((r) => <span key={r} className="rounded-full border border-border bg-secondary/40 px-2.5 py-1 text-xs">{r}</span>)}
        </div>
      )}
    </>
  );
};
